<template>
  <section class="p-1" aria-labelledby="basket-summary-title" tabindex="-1" role="region">
    <div class="checkout-container">
      <h2 id="basket-summary-title" class="title py-1">
        <span class="text-left">{{ title || $t('subTitle.shoppingCart') }}</span>
      </h2>
    </div>
    <div>
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/css/customizer';

.checkout-container {
  background: var(--custom-basket-group-color, var(--page-group-header));
  padding: 0 10px;
  border-radius: var(--button-border-radius);
  width: 100%;
  margin-bottom: 10px;
}

.checkout-container + .checkout-container {
  margin-top: 10px;
}

.title {
  font-size: 20px;
  color: custom-chain(mealplan-group-color-text,var(--page-group-title));
  display: flex;
  justify-content: space-between; /* Space between the two spans */
  align-items: center; /* Center the text vertically */
  width: 100%; /* Ensure it takes the full width */
}
</style>
